module.exports = __webpack_public_path__ + "static/media/sun_logo.b1bb9502.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/details/imgs/sun_logo.png
// module id = 1162
// module chunks = 0